import axios from 'axios'
import router from './../../../router'
import {Errors, Form} from './../../../components/validations/forms.js'
const namespaced = true;

const state = {
  shifts: [],
  shiftPlans: [],
  shiftPlans2: [],
  shiftCategories: [],
  shiftDayPolicies: [],

  defaultSearchFilter: {
    companies: [],
    companies2: [],
    sponsorCompanies: [],
    sponsorCompanies2: [],
    branches: [],
    branches2: [],
    departments: [],
    departments2: [],
    cities: [],
    cities2: [],
    nationalities: [],
    nationalities2: [],
    designations: [],
    designations2: [],
    religions: [],
    religions2: [],
    shiftPlans: [],
    shiftPlans2: [],
    employees: [],
    employees2: [],
    dateFrom: null,
    dateTo: null,
    status: [],
    status2: [],
    isActive: false,
    resultsView: 'shift',
  },
  searchFilter: {
    companies: [],
    companies2: [],
    sponsorCompanies: [],
    sponsorCompanies2: [],
    branches: [],
    branches2: [],
    departments: [],
    departments2: [],
    cities: [],
    cities2: [],
    nationalities: [],
    nationalities2: [],
    designations: [],
    designations2: [],
    religions: [],
    religions2: [],
    shiftPlans: [],
    shiftPlans2: [],
    employees: [],
    employees2: [],
    dateFrom: null,
    dateTo: null,
    status: [],
    status2: [],
    isActive: false,
    resultsView: 'shift',
  },

  sorting: {
    page: 1,
    sortBy: 'shift',
    sortOrder: 'desc',
    limit: 200,
  },

  timesheetUsers: [],
  timesheetPages: [],

  allowedShiftPlans: [],
};

const getters = {
  getShifts (state) {
    return state.shifts
  },

  getShiftCategories (state) {
    return state.shiftCategories
  },

  getShiftPlans (state) {
    return state.shiftPlans
  },

  getAllowedShiftPlans (state) {
    return state.allowedShiftPlans
  },

  getShiftPlans2 (state) {
    return state.shiftPlans2
  },

  getShiftDayPolicies (state) {
    return state.shiftDayPolicies
  },

  getDefaultSearchFilters (state) {
    return state.defaultSearchFilter
  },

  getSearchFilters (state) {
    return state.searchFilter
  },

  getSorting (state) {
    return state.sorting
  },

  getTimesheetPages (state) {
    return state.timesheetPages
  },

  getTimesheetUsers (state) {
    return state.timesheetUsers
  },


};


const mutations = {

  setShifts (state, payload) {
    state.shifts = payload
  },

  setShiftCategories (state, payload) {
    state.shiftCategories = payload
  },

  setShiftPlans (state, payload) {
    state.shiftPlans = payload
  },

  setAllowedShiftPlans (state, payload) {
    state.allowedShiftPlans = payload
  },

  setShiftPlans2 (state, payload) {
    state.shiftPlans2 = payload
  },

  setShiftDayPolicies (state, payload) {
    state.shiftDayPolicies = payload
  },

  resetSearchFilters (state, payload){
    state.searchFilter = JSON.parse(JSON.stringify(state.defaultSearchFilter));
    console.log('Search Filter Reset')
  },

  setTimesheetPages (state, payload) {
    state.timesheetPages = payload
  },

  setTimesheetUsers (state, payload) {
    state.timesheetUsers = payload
  },

};


const actions = {

  fetchShifts ({commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {
      let params = new URLSearchParams();
      axios.defaults.baseURL = hostnames[Math.floor(Math.random()*hostnames.length)]
      axios.get('/api/attendance/shift', {
        params: {
        }
      })
        .then(res => {
          commit('setShifts', res.data.data)
          console.log('fetchShifts - fetchShifts Fetched.');
          resolve(res.data.data);
        })
        .catch(error => {
          const issues = new Errors();
          issues.record(error.response);
          reject(issues);
        })
    })
  },

  fetchShiftPlans ({commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {
      let params = new URLSearchParams();
      axios.defaults.baseURL = hostnames[Math.floor(Math.random()*hostnames.length)]
      axios.get('/api/attendance/shift_plan', {
        params: {
          // filtered: 2
        }
      })
        .then(res => {
          commit('setShiftPlans', res.data.data)
          console.log('fetchShiftPlans - fetchShiftPlans Fetched.');
          resolve(res.data.data);
        })
        .catch(error => {
          const issues = new Errors();
          issues.record(error.response);
          reject(issues);
        })
    })
  },
  fetchShiftPlans2 ({commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {
      let params = new URLSearchParams();
      axios.defaults.baseURL = hostnames[Math.floor(Math.random()*hostnames.length)]
      axios.get('/api/attendance/shift_plan', {
        params: {
          filtered: 2
        }
      })
          .then(res => {
            commit('setShiftPlans2', res.data.data)
            console.log('fetchShiftPlans - fetchShiftPlans Fetched.');
            resolve(res.data.data);
          })
          .catch(error => {
            const issues = new Errors();
            issues.record(error.response);
            reject(issues);
          })
    })
  },

  fetchAllowedShiftPlans({commit, dispatch}, payload) {
    // return new Promise((resolve, reject) => {
    //   let params = new URLSearchParams();
    //   axios.defaults.baseURL = hostnames[Math.floor(Math.random()*hostnames.length)]
    //   axios.get('/api/attendance/shift_plan', {
    //     params: {
    //       filtered: 2
    //     }
    //   })
    //       .then(res => {
    //         commit('setShiftPlans2', res.data.data)
    //         console.log('fetchShiftPlans - fetchShiftPlans Fetched.');
    //         resolve(res.data.data);
    //       })
    //       .catch(error => {
    //         const issues = new Errors();
    //         issues.record(error.response);
    //         reject(issues);
    //       })
    // })
  },

  makePlans ({commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {
      let params = new URLSearchParams();
      axios.defaults.baseURL = hostnames[Math.floor(Math.random()*hostnames.length)]
      axios.get('/api/attendance/shift/recycle', {
        params: {
        }
      })
          .then(res => {
            console.log('makePlans - makePlans Fetched.');
            resolve(res.data.data);
          })
          .catch(error => {
            const issues = new Errors();
            issues.record(error.response);
            reject(issues);
          })
    })
  },
  fetchShiftDayPolicies ({commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {
      let params = new URLSearchParams();
      axios.defaults.baseURL = hostnames[Math.floor(Math.random()*hostnames.length)]
      axios.get('/api/attendance/shift_day_policy', {
        params: {
        }
      })
        .then(res => {
          commit('setShiftDayPolicies', res.data.data)
          console.log('setShiftDayPolicies - setShiftDayPolicies Fetched.');
          resolve(res.data.data);
        })
        .catch(error => {
          const issues = new Errors();
          issues.record(error.response);
          reject(issues);
        })
    })
  },



  updateShift ({commit, dispatch}, payload) {
    if(payload.recycle){payload.recycle = 1;}
    return new Promise((resolve, reject) => {
      axios.defaults.baseURL = hostnames[Math.floor(Math.random()*hostnames.length)]
      axios.put('/api/attendance/shift/'+payload.id, {
        name: payload.name,
        period: payload.period,
        reprocess: payload.reprocess,
        category: payload.category,
        recycle: payload.recycle,
        days: payload.days
      })
          .then(res => {
            console.log('updateShift - updateShift Updated.');
            resolve(res.data);
          })
          .catch(error => {
            reject(error.response);
          })
    })
  },

  fetchShift ({commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {
      axios.defaults.baseURL = hostnames[Math.floor(Math.random()*hostnames.length)]
      axios.get('/api/attendance/shift/'+payload.id, {
        //
      })
          .then(res => {
            console.log('fetchShift - fetchShift Updated.');
            resolve(res.data);
          })
          .catch(error => {
            reject(error.response);
          })
    })
  },

  fetchShiftPlan ({commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {
      axios.defaults.baseURL = hostnames[Math.floor(Math.random()*hostnames.length)]
      axios.get('/api/attendance/shift_plan/'+payload.id, {
        //
      })
          .then(res => {
            console.log('fetchShiftPlan - fetchShiftPlan Updated.');
            resolve(res.data);
          })
          .catch(error => {
            reject(error.response.data);
          })
    })
  },

  reprocessAttendance ({commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {
      axios.defaults.baseURL = hostnames[Math.floor(Math.random()*hostnames.length)]
      axios.get('/api/attendance/shift_plan/reprocessAttendance?shiftPlanID='+payload)
          .then(res => {
            console.log('Shift Plan Attendance Reprocessed.');
            resolve(res.data);
          })
          .catch(error => {
            reject(error.response);
          })
    })
  },

  makeAttendance ({commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {
      axios.defaults.baseURL = hostnames[Math.floor(Math.random()*hostnames.length)]
      axios.get('/api/attendance/attendance/makeAttendance')
          .then(res => {
            console.log('Shift Plan Attendance Reprocessed.');
            resolve(res.data);
          })
          .catch(error => {
            reject(error.response);
          })
    })
  },

  storeShift ({commit, dispatch}, payload) {
    if(payload.recycle){payload.recycle = 1;}
    return new Promise((resolve, reject) => {
      axios.defaults.baseURL = hostnames[Math.floor(Math.random()*hostnames.length)]
      axios.post('/api/attendance/shift', {
        name: payload.name,
        period: payload.period,
        reprocess: payload.reprocess,
        category: payload.category,
        recycle: payload.recycle,
        days: payload.days
      })
        .then(res => {
          console.log('storeShift - storeShift Updated.');
          resolve(res.data);
        })
        .catch(error => {
          reject(error.response);
        })
    })
  },

  deleteShift ({commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {
      axios.defaults.baseURL = hostnames[Math.floor(Math.random()*hostnames.length)]
      axios.delete('/api/attendance/shift/'+payload.id)
        .then(res => {
          console.log('deleteShift - deleteShift Updated.');
          resolve(res.data);
        })
        .catch(error => {
          reject(error.response);
        })
    })
  },

  updateShiftPlans ({commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {
      axios.defaults.baseURL = hostnames[Math.floor(Math.random()*hostnames.length)]
      axios.put('/api/attendance/shift_plan/'+payload.id, {
        name: payload.name,
        reprocess: payload.reprocess,
        startDate: payload.startDate,
        endDate: payload.endDate,
        shifts_id: payload.shifts_id,
        sortOrder: payload.sortOrder,
      })
          .then(res => {
            console.log('updateShift - updateShift Updated.');
            resolve(res.data);
          })
          .catch(error => {
            reject(error.response);
          })
    })
  },

  storeShiftPlans ({commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {
      axios.defaults.baseURL = hostnames[Math.floor(Math.random()*hostnames.length)]
      axios.post('/api/attendance/shift_plan', {
        name: payload.name,
        reprocess: payload.reprocess,
        startDate: payload.startDate,
        endDate: payload.endDate,
        shifts_id: payload.shiftID,
        sortOrder: payload.sortOrder,
      })
          .then(res => {
            console.log('storeShift - storeShift Updated.');
            resolve(res.data);
          })
          .catch(error => {
            reject(error.response);
          })
    })
  },

  deleteShiftPlans ({commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {
      axios.defaults.baseURL = hostnames[Math.floor(Math.random()*hostnames.length)]
      axios.delete('/api/attendance/shift_plan/'+payload.id)
          .then(res => {
            console.log('deleteShift - deleteShift Updated.');
            resolve(res.data);
          })
          .catch(error => {
            reject(error.response);
          })
    })
  },

  assignShiftPlan ({commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/api/attendance/shift_plan/toggleUser', {
        userIDs: [payload.userID],
        shiftPlanID: payload.shiftPlanID,
      })
          .then(res => {
            console.log('assignShiftPlan - Shift Plan Toggled.');
            resolve(res.data);
          })
          .catch(error => {
            reject(error.response);
          })
    })
  },

  fetchTimesheetUsers ({commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {
      let params = new URLSearchParams();
      axios.defaults.baseURL = hostnames[Math.floor(Math.random()*hostnames.length)]
      axios.get('/api/attendance/user', {
        params: {
          companies: payload.filters.companies,
          sponsorCompanies: payload.filters.sponsorCompanies,
          branches: payload.filters.branches,
          departments: payload.filters.departments,
          cities: payload.filters.cities,
          nationalities: payload.filters.nationalities,
          designations: payload.filters.designations,
          religions: payload.filters.religions,
          shiftPlans: payload.filters.shiftPlans,
          employees: payload.filters.employees,
          status: payload.filters.status,
          resultsView: payload.filters.resultsView,
          limit: payload.sorting.limit,
          page: payload.sorting.page,
          sortBy: payload.sorting.sortBy,
          sortOrder: payload.sorting.sortOrder,
        }
      })
          .then(res => {
            commit('setTimesheetUsers', res.data.data)
            commit('setTimesheetPages', {meta: res.data.meta, links:res.data.links})

            console.log('fetchTimesheetUsers - fetchTimesheetUsers Fetched.');
            resolve(res.data.data);
          })
          .catch(error => {
            const issues = new Errors();
            issues.record(error.response);
            reject(issues);
          })
    })
  },


  fetchShiftCategories ({commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {
      let params = new URLSearchParams();
      axios.defaults.baseURL = hostnames[Math.floor(Math.random()*hostnames.length)]
      axios.get('/api/attendance/shift_categories', {
        params: {
          id: payload,
        }
      })
          .then(res => {
            commit('setShiftCategories', res.data.data)
            console.log('fetchShiftCategories - fetchShiftCategories Fetched.');
            resolve(res.data.data);
          })
          .catch(error => {
            const issues = new Errors();
            issues.record(error.response);
            reject(issues);
          })
    })
  },

  storeShiftCategories ({commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {
      axios.defaults.baseURL = hostnames[Math.floor(Math.random()*hostnames.length)]
      axios.post('/api/attendance/shift_categories', {
        name: payload.name,
      })
          .then(res => {
            console.log('storeShiftCategories - storeShiftCategories Updated.');
            resolve(res.data);
          })
          .catch(error => {
            reject(error.response);
          })
    })
  },

  updateShiftCategories ({commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {
      axios.defaults.baseURL = hostnames[Math.floor(Math.random()*hostnames.length)]
      axios.put('/api/attendance/shift_categories/'+payload.id, {
        id: payload.id,
        name: payload.name,
      })
          .then(res => {
            console.log('updateShiftCategories - updateShiftCategories Updated.');
            resolve(res.data);
          })
          .catch(error => {
            reject(error.response);
          })
    })
  },

  deleteShiftCategories ({commit, dispatch}, payload) {
    return new Promise((resolve, reject) => {
      axios.defaults.baseURL = hostnames[Math.floor(Math.random()*hostnames.length)]
      axios.put('/api/attendance/shift_categories/'+payload, {
        id: payload,
        delete: 1,
      })
          .then(res => {
            console.log('deleteShiftCategories - deleteShiftCategories Updated.');
            resolve(res.data);
          })
          .catch(error => {
            reject(error.response);
          })
    })
  },

  resetSearchFilters ({commit, dispatch}) {
    commit('resetSearchFilters');
    console.log('Search Filters were reset');
  },

};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/attendance/shifts.js